export default __webpack_public_path__ + "static/media/fastlane_detail5.ccee74c0.jpg";